import React, { useContext } from 'react';
import { IconUiSuccessOutlined } from '@uberall/zenit';

import styles from './access-granted-body.module.css';
import sharedStyles from '../../../sharedStyles.module.css';
import { MainContentContainer } from '../../main-content-container';
import Message from '../../Message';
import { RequestAccessFormContext } from '../../../contexts/request-access-form-context';
import { useFetchRequestAccessForm } from '../../../api/hooks/useFetchRequestAccessForm';
import { RequestAccessForm } from '../../../api/types';

const AccessGrantedBody = () => {
    const { userEmail } = useContext(RequestAccessFormContext);
    const { data } = useFetchRequestAccessForm() as { data: RequestAccessForm };

    return (
        <MainContentContainer className={styles.content}>
            <div className={styles.headline}>
                <h1 className={sharedStyles.textHeadline}>
                    <Message code="app.request.access.public.step.3.access.granted.title"></Message>
                </h1>

                <IconUiSuccessOutlined className={styles.iconHeadline} />
            </div>
            <Message
                code="app.request.access.public.step.3.access.granted.subtitle"
                interpolationValues={{ email: userEmail }}
            />
            <div className={styles.requestInfo}>
                <span>
                    <Message
                        className={sharedStyles.textBold}
                        code="app.request.access.public.step.1.requestedBy"
                    />{' '}
                    {data?.directoryUserAccountEmail}
                </span>
                <span>
                    <Message
                        className={sharedStyles.textBold}
                        code="app.request.access.public.step.1.accessLevel"
                    />{' '}
                    <Message code={`app.request.access.public.access.level.${data?.accessType.toLowerCase()}`} />
                </span>
            </div>
        </MainContentContainer>
    );
};

export default AccessGrantedBody;
